 
import { call, select, takeLatest } from 'redux-saga/effects';
import { fetchInstitutions } from '@api/teamMembers';
import { actions } from './teamFilters.slice';
import { TeamFiltersFetchInstitutionsAction } from './teamFilters.types';
import { Resp, dispatch } from '../helpers';
import { selectUsersListState } from '../usersList/usersList.slice';
import { OrganizationType } from '@dynamika-shared/types/inventory';


export const transformInstitution = (
  teamInstitutions: string[] = [],
  usersInstitutions: OrganizationType[] = []
) =>
  teamInstitutions.map(i => {
    const org = usersInstitutions.find(org => org.id === i);
    return {
      label: org?.name ?? i,
      value: i,
    };
  });

export function* fetchInstitutionsWorker(
  action: TeamFiltersFetchInstitutionsAction
) {
  const clinicalTrialId = action.payload;
  try {
    const response: Resp<typeof fetchInstitutions> = yield call(
      fetchInstitutions,
      clinicalTrialId
    );

    const usersListState: ReturnType<typeof selectUsersListState> =
      yield select(selectUsersListState);

    const institutions: ReturnType<typeof transformInstitution> = yield call(
      transformInstitution,
      response?.data,
      usersListState?.institutions
    );

    yield dispatch(actions.fetchInstitutionsSuccess(institutions));
  } catch (error) {
    yield dispatch(actions.fetchInstitutionsFailure(error as Error));
  }
}

export function* teamFiltersSaga() {
  yield takeLatest(actions.fetchInstitutions.type, fetchInstitutionsWorker);
}
